import { render } from "./SpotShow.vue?vue&type=template&id=796f4b8e"
import script from "./SpotShow.vue?vue&type=script&lang=js"
export * from "./SpotShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__